import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles/tokens.css'
import './styles/base.css'
import './styles/landing.css'
import './styles/workspace.css'
import './styles/results.css'

const rootElement = document.getElementById('root')

if (!rootElement) throw new Error('应用挂载节点不存在。')

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
